import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

export const panelStyle = (customStyle?: CSSProperties) => ({
  minWidth: '720px',
  width: '100%',
  top: 45,
  backgroundColor: 'rgb(244 244 244)',
  borderLeft: '1px solid #e0e0e0',
  borderRight: '1px solid #e0e0e0',
  ...customStyle,
});

interface StyledDivProps {
  children?: ReactNode;
  minWidth?: number;
  isHidden?: boolean;
  onClick?: any;
  ref?: any;
}

export const InputsWrapper = styled.div<StyledDivProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div<StyledDivProps>`
  display: flex;
  justify-content: center;
  position: relative;
  height: 45px;
`;

export const FilterWrapper = styled.div<StyledDivProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;

  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth}px;
    `}
`;

export const FilterLabel = styled.div<StyledDivProps>`
  width: 30%;
  font-size: 14px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const FilterItem = styled.div<StyledDivProps>`
  margin-bottom: 5px;
  width: 100%;
`;

export const ButtonWrapper = styled.div<StyledDivProps>`
  width: fit-content;
  align-self: flex-end;
  margin-top: 20px;
  display: flex;
`;

export const Margin = styled.div<StyledDivProps>`
  margin-right: 10px;
`;

export const ClearIcon = styled.div<StyledDivProps>`
  margin-left: 10px;

  ${({ isHidden }) =>
    isHidden &&
    css`
      visibility: hidden;
    `}
`;

interface IconImgProps {
  src?: string;
  alt?: string;
  onClick?: any;
}

export const IconImg = styled.img<IconImgProps>`
  :hover {
    cursor: pointer;
  }
`;

interface ButtonProps {
  children?: ReactNode;
  onClick?: any;
}

export const ClearButton = styled.button<ButtonProps>`
  position: absolute;
  right: 50px;
  padding: 4px 25px;
  border-radius: 5px;
  border: none;
  top: 0;
  transform: translateY(50%);
  text-align: center;
  background-color: ${({ theme }) => theme.palette.backgrounds.chip};
  color: ${({ theme }) => theme.palette.text.secondary};

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.palette.hover.chip};
  }
`;

export const ButtonsWrapper = styled.div<StyledDivProps>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Chip = styled.div<StyledDivProps>`
  background-color: ${({ theme }) => theme.palette.backgrounds.chip};
  color: ${({ theme }) => theme.palette.text.secondary};
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 400;
`;

export const ChipButton = styled.div<StyledDivProps>`
  background-color: ${({ theme }) => theme.palette.backgrounds.chip};
  color: ${({ theme }) => theme.palette.text.secondary};
  border-radius: 10%;
  width: 60px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  margin: 0 10px;
`;
